<template>
  <ReachInput
      :grid-editor="gridEditor"
      :open-from-grid="openFromGrid"
      ref="input"
      :formField="validatedField"
      :field-config="fieldConfig"
      :read-only="readOnly || !validatedField || validatedField.readOnly"
      :editor-mode="editorMode"
      :label="fieldConfig.labelOnly ? '\u00A0' : fieldConfig.fieldLabel"
      :hint="fieldConfig.labelOnly ? '' :fieldConfig.shortHelpText"
      :help-title="fieldConfig.labelOnly ? '' : fieldConfig.helpWindowTitle"
      :help-message="fieldConfig.labelOnly ? '' :fieldConfig.htmlHelpText"
      :initialFocus="fieldConfig.autofocus"
      :mode="mode"
      :parent-form="parentForm"
      @input="emitInput"
  >

  </ReachInput>
</template>

<script>
import ReachInput from "@/components/inputs/ReachInput";
import FormValidatedField from "@/components/forms/FormValidatedField";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";
import FormModel from "@/components/forms/FormModel";

export default {
  name: "SingleLineTextRenderer",
  components: {ReachInput},
  mounted(){
  },
  props:{
    validatedField: { type: FormValidatedField, required:true },
    fieldConfig: { type: TextFormFieldConfig, required:true },
    mode: {default: null},
    openFromGrid: {default: false},
    gridEditor: {default: null},
    parentForm: {type: FormModel}
  },

  methods:{
    emitInput(val){
      this.$emit('input', val);
    },
    setReadOnly(readOnly){
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    setEditorMode(val){
      this.editorMode = val;
    }
  },

  data: () => ({
    readOnly: true,
    editorMode: false,
  })
}
</script>

<style scoped>

</style>